module.exports = __webpack_public_path__ + "img/schemeList02Display02.acc74deb.jpg";